import React, { useState } from 'react';
import { useSendMessage } from 'crustate/react';
import { useTranslate } from '@awardit/react-use-translate';
import { Checkbox, Input } from '@crossroads/ui-components';
import { Box, BoxHeader, BoxBody } from '../Box/index.js';
import { Button } from '../Button/index.js';
import styles from 'shop-views/DiscountCode.scss';

/* eslint-disable react/boolean-prop-naming */
var DiscountCode = _ref => {
  var _ref$coupon = _ref.coupon,
      coupon = _ref$coupon === void 0 ? {
    code: "",
    label: ""
  } : _ref$coupon,
      setSummaryOpen = _ref.setSummaryOpen,
      disabled = _ref.disabled,
      setQuoteDiscountCode = _ref.setQuoteDiscountCode,
      removeQuoteDiscountCode = _ref.removeQuoteDiscountCode;
  var t = useTranslate();
  var sendMessage = useSendMessage();

  var _useState = useState(coupon ? coupon.code : ""),
      discountCode = _useState[0],
      setDiscountCode = _useState[1];

  var _useState2 = useState(coupon ? Boolean(coupon.code) : false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var removeCode = () => {
    sendMessage(removeQuoteDiscountCode());
    setDiscountCode("");
    setSummaryOpen(true);
    setOpen(false);
  };

  var onSubmit = e => {
    if (e) {
      e.preventDefault();
    }

    if (discountCode.length === 0 || disabled === true) {
      return;
    }

    sendMessage(setQuoteDiscountCode(discountCode));
    setSummaryOpen(true);
  };

  var onRemove = e => {
    if (e) {
      e.preventDefault();
    }

    if (disabled === true) {
      return;
    }

    removeCode();
  };

  return /*#__PURE__*/React.createElement(Box, {
    className: styles.block
  }, /*#__PURE__*/React.createElement(BoxHeader, {
    className: styles.boxHeader
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
    type: "checkbox",
    name: "checkDiscountCode",
    value: open,
    onChange: () => setOpen(!open)
  }, t("CHECKOUT.DISCOUNT_CODE.CHECKBOX_LABEL")))), open && /*#__PURE__*/React.createElement(BoxBody, null, /*#__PURE__*/React.createElement("div", {
    className: styles.discountCode
  }, /*#__PURE__*/React.createElement(Input, {
    label: t("CHECKOUT.DISCOUNT_CODE.HEADER"),
    name: "discountCode",
    disabled: coupon || disabled,
    value: discountCode,
    onChange: e => {
      setDiscountCode(e.currentTarget.value);
    },
    onKeyUp: e => {
      if (e.key === "Enter") {
        onSubmit();
      }
    }
  }), /*#__PURE__*/React.createElement(Button, {
    className: styles.button,
    variant: "primary",
    onClick: coupon ? onRemove : onSubmit
  }, coupon ? t("CHECKOUT.DISCOUNT_CODE.REMOVE") : t("CHECKOUT.DISCOUNT_CODE.APPLY")))));
};

export { DiscountCode };
//# sourceMappingURL=index.js.map
